// removed by extract-text-webpack-plugin
module.exports = {"title":"_2Lyl9tkSA-HK_SO86TuTEl","buttonNew":"_1zqywJ-4X29yJYrVttDQMq"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Actions/style.scss
// module id = 1249
// module chunks = 0